<template>
  <div class="relative p-4">
    <button
      type="button"
      class="button w-full button bg-yellow-brand text-blue-dark transition-colors hover:bg-yellow-light"
      @click.prevent="onClick"
      :disabled="!approved"
    >
      {{ this.approved ? 'Pay outstanding amount' : 'Booking pending approval' }}
    </button>
    <button type="button" class="absolute p-4 top-6 right-4 flex items-center justify-center cursor-pointer" v-if="incompleteGuests > 0" @click.prevent="onClickHelp">
      <svg-sprite href="icon-tooltip" class="w-4 h-4"></svg-sprite>
    </button>
    <invisible-payment-form :details="paymentFormDetails"></invisible-payment-form>
  </div>
</template>

<script>
import Route from '../src/Route';
import InvisiblePaymentForm from './InvisiblePaymentForm.vue';
export default {
  components: { InvisiblePaymentForm },

  props: {
    bookingUuid: {
      type: String,
      required: true,
    },
    approved: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      gettingFormDetails: false,
      errorMessage: null,
      errors: [],
      paymentFormDetails: null,
    };
  },

  computed: {
    incompleteGuests() {
      return this.$store.state.details.incompleteGuests;
    }
  },

  methods: {
    onClick() {
      this.gettingFormDetails = true;
      axios
        .get(Route('json.payments.show'), {
          params: {
            booking_id: this.bookingUuid,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            throw 'Error';
          }

          // Setting this will create the form which
          // will automatically submit itself
          this.paymentFormDetails = response.data.worldpay_details;
        })
        .catch(e => {
          if ([422, 403].includes(get(e, 'response.status'))) {
            this.errors = get(e, 'response.data.errors');
            this.errorMessage = get(e, 'response.data.message');
          }
          console.error(e)
        })
        .then(() => {
          this.gettingFormDetails = false;
        });
    },

    onClickHelp() {
      // This is a filthy hack as we have no easy way to get this
      // information or interact with these other components.
      this.$root.$refs.tabContainer.setTab('details');
      this.$parent.closeSidebar();
      let top = window.pageYOffset + this.$root.$refs.tabContainer.$el.getBoundingClientRect().top;

      this.$nextTick(function () {
        window.scrollTo(0, top);
      });
    },
  }
};
</script>
